import React from "react";
import PropTypes from "prop-types";

import { Button, Spinner } from "reactstrap";

function LoadingButton({
  loading,
  loadingText,
  disabled,
  children,
  spinnerProps,
  ...props
}) {
  const text = loading ? (
    <>
      <Spinner
        type="border"
        color={spinnerProps?.color ?? "light"}
        role="status"
        style={{ borderWidth: "1.5px", width: "1rem", height: "1rem" }}
      />{" "}
      {loadingText}
    </>
  ) : (
    children
  );

  return (
    <Button {...props} disabled={disabled || loading}>
      {text}
    </Button>
  );
}

LoadingButton.propTypes = {};

export default LoadingButton;
